export const calculateAnimationValuesForCard = (
  index: number,
  total: number,
  offset: number,
) => {
  const distance = index - total / 2;
  const offsetX = distance * -20 + "px";
  const offsetY = distance * 4 + "vh";
  const delay = Math.abs(distance) * offset;

  return { offsetX, offsetY, delay };
};

// Utility to manage visible card indices as we transition current index.
export const getFrontAndBackCardIndices = (
  currentIndex: number,
  totalCards: number,
) => {
  const indexIsEven = currentIndex % 2 === 0;

  // We will swap the card index based on the current index.
  // Since index is the "next" card index, we want to ensure the first card does not flash to the current card,
  // as we are transitioning the animation value. This is then reversed for the back card.
  const frontCardIndex = indexIsEven
    ? currentIndex
    : Math.max(currentIndex - 1, 0);
  const backCardIndex = !indexIsEven
    ? currentIndex
    : Math.max(currentIndex - 1, 0);
  return [
    (frontCardIndex + totalCards) % totalCards,
    (backCardIndex + totalCards) % totalCards,
  ];
};
